import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'
import Portal from '@mui/material/Portal'
import { ReactNode } from 'react'
import styles from './LoadingOverlay.pcss'

interface LoadingOverlayProps {
  open: boolean
  message: ReactNode
}

export function LoadingOverlay(props: LoadingOverlayProps) {
  const composerDialog = document.querySelector('[data-testid="composer-dialog"]')

  return (
    <Portal container={composerDialog}>
      <Backdrop open={props.open} className={styles.backdrop} data-testid="composer-loading-overlay">
        <div className={styles['loader-content']}>
          <CircularProgress />
          <p>{props.message}</p>
        </div>
      </Backdrop>
    </Portal>
  )
}

export default LoadingOverlay
